/**
 * Derives the contact drawer's primary CTA from the contact's reachability.
 *
 * Pure + single-purpose. The header CTA is email-only: a cold Instagram DM is
 * forbidden, so a DM is never offered here (that shortcut lives in the detail
 * context bar and only when an active thread already exists). When the contact
 * has no email the button still reads as the email action but renders disabled,
 * so the header shows a greyed-out "send a message" affordance with a tooltip
 * rather than an ambiguous "no channel" state.
 */
export interface ContactPrimaryAction {
  labelKey: string;
  icon: 'Mail';
  channel: 'email';
  disabled: boolean;
}

export const deriveContactPrimaryAction = (input: { hasEmail: boolean }): ContactPrimaryAction => ({
  channel: 'email',
  icon: 'Mail',
  labelKey: 'contactDrawer.actions.sendMessage',
  disabled: !input.hasEmail,
});
